import React from 'react';
import { Modal } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPrint, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../../components/Button/Button';
import classes from './no-bill-warning-modal.module.scss';

export type NoBillWarningModalProps = {
  opened: boolean;
  onClose: () => void;
};

// Summary: Payment-screen warning that this dine-in order reached payment without a printed bill.
const NoBillWarningModalComponent: React.FC<NoBillWarningModalProps> = ({ opened, onClose }) => (
  <Modal
    opened={opened}
    onClose={onClose}
    size="sm"
    centered
    radius="lg"
    dir="rtl"
    withCloseButton={false}
    closeOnClickOutside={false}
    closeOnEscape={false}
    classNames={{ content: classes.content, body: classes.modalBody }}
  >
    <div className={classes.header}>
      <FontAwesomeIcon icon={faTriangleExclamation as IconProp} className={classes.icon} />
      <h2 className={classes.title}>שים לב!</h2>
    </div>
    <div className={classes.body}>
      <p className={classes.message}>
        להזמנה זו <strong>לא הודפס חשבון</strong> לפני המעבר לתשלום
      </p>
      <div className={classes.hint}>
        <FontAwesomeIcon icon={faPrint as IconProp} className={classes.hintIcon} />
        <span>מומלץ להדפיס חשבון ולהציגו ללקוח לפני הסגירה</span>
      </div>
      <Button variant="confirm" onClick={onClose} fullWidth dataTestId="no-bill-warning-confirm">
        <FontAwesomeIcon icon={faCheck as IconProp} /> הבנתי, המשך
      </Button>
    </div>
  </Modal>
);

export const NoBillWarningModal = React.memo(NoBillWarningModalComponent);
